export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-semibold mb-4 whitespace-nowrap">
            Buyer Safety
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-3">
            Shop Smart & Stay Safe
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Our platform provides information and resources to help you make informed buying decisions. Always exercise due diligence when shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[
            { title: 'Review Seller Ratings', desc: 'Always check seller ratings and community feedback before making a purchase through any platform.', icon: 'ri-star-line' },
            { title: 'Check QC Photos', desc: 'Review quality control photos carefully. Request additional photos if product details are unclear.', icon: 'ri-image-line' },
            { title: 'Compare Products', desc: 'Browse multiple seller options for the same item. Comparing prices helps you find the best deals.', icon: 'ri-scales-line' },
            { title: 'Use Trusted Agents', desc: 'Work with verified buying agents who have established reputations in the community.', icon: 'ri-shield-check-line' },
            { title: 'Read Buying Guides', desc: 'Our AllChinaBuy Spreadsheet guide covers shipping, sizing, and money-saving strategies for beginners.', icon: 'ri-book-open-line' },
            { title: 'Stay Updated', desc: 'The allchinabuyspreadsheet is updated daily. Check back regularly for the latest verified seller links.', icon: 'ri-refresh-line' },
          ].map((item) => (
            <div key={item.title} className="bg-white rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-secondary-600 text-base`}></i>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-foreground-400 mt-8 max-w-2xl mx-auto leading-relaxed">
          Disclaimer: AllChinaBuySpreadsheet.asia is an independent information resource. We are not affiliated with AllChinaBuy. All product links direct to kaspreadsheet.com. Buy responsibly and always review seller information before purchasing.
        </p>
      </div>
    </section>
  );
}